<template>
  <div>
    <flat-pickr
      v-model="val"
      :config="{
        locale: Korean,
        mode: isRange === true ? 'range' : 'single',
        disableMobile: true,
      }"
      class="form-control"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
import flatPickr from "vue-flatpickr-component";
import { Korean } from "flatpickr/dist/l10n/ko";

const eventName = "change";
const eventSource = "model";
const rangeDelimiter = " ~ ";

export default {
  name: "EpiDatePicker",
  components: { flatPickr },
  props: [eventSource, "isRange", "placeholder"],
  model: {
    prop: eventSource,
    event: eventName,
  },
  computed: {
    val: {
      get() {
        const v = this[eventSource];
        if (!v) return v;
        if (this.isRange) return v.join(rangeDelimiter);
        else return v;
      },
      set(v) {
        if (this.isRange) this.$emit(eventName, v.split(rangeDelimiter));
        else this.$emit(eventName, v);
      },
    },
  },
  data() {
    return {
      Korean,
      val2: null,
    };
  },
};
</script>
